<div id="map" #leafletMap style="height:100%; border-radius: 30px;"></div>